export const attachCandidateActionTypes = {
  UPDATE: '@attachCandidate/update',
} as const;
